<template>
  <button
    :class="cssClass"
    @click="$router.go(-1)"
  >
    <img
      :src="imgsrc"
      alt="back"
      width="24"
    >
  </button>
</template>

<script>
import WhiteArrow from '../assets/back-arrow.png'
import BlackArrow from '../assets/back-arrow-blk.png'

export default {
  name: 'BackButton',
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    imgsrc () {
      return this.cssClass === 'reverse' ? BlackArrow : WhiteArrow
    }
  }
}
</script>
